import React from 'react'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import BasicLgyTextArea from 'app/components/util/lgy-text-area/BasicLgyTextArea'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'

const AddNoteSection = ({ handleSubmit, handleChange, handleInvalid, handleReset, noteUploads, invalidMessage, accessIndicator, noteType, noteText }) =>
  <LgySubsection header='Add Note' className='notes-form usa-width-one-whole'>
    <form className='usa-form' onSubmit={handleSubmit}>
      <fieldset className='usa-fieldset-inputs'>
        <legend className='usa-sr-only'>Add Note Form</legend>
        <BasicLgyCheckbox id='accessIndicator' label='Public Access Indicator' autoFocus
          name='accessIndicator' value={accessIndicator} onChange={handleChange} />
        <BasicLgySelectField id='noteType' label='Note Type:' required
          name='noteType' value={noteType} onChange={handleChange} onInvalid={handleInvalid}
          error={invalidMessage.some(e => e === 'noteType') ? 'Required' : undefined}>
          <option value='NAT'>No Access to Subject Property: Need Access Contact Information</option>
          {/*tidewater is being hidden per PMDI request as of 20.5, uncomment below to display*/}
          {/*<option value='TID'>Appraiser Invoked Tidewater</option>*/}
          <option value='DIA'>Delay in Appointment</option>
          <option value='CNP'>Contract Not Provided</option>
          <option value='PNR'>New Construction: Property Not Ready</option>
          <option value='DAP'>Delay in appraisal process (see notes)</option>
          <option value='APR'>Other: (see notes)</option>
        </BasicLgySelectField>
        <BasicLgyTextArea id='noteText' label='Note Text:' placeholder='Note Text' maxLength='4000' required
          tooltip='Notes are for documentation purposes only. If you require assistance, please contact the RLC of jurisdiction directly.'
          name='noteText' value={noteText} onChange={handleChange} onInvalid={handleInvalid}
          error={invalidMessage.some(e => e === 'noteText') ? 'Required' : undefined} />
      </fieldset>
      <LgyFormSubmit
        pristine={!accessIndicator && !noteType && !noteText}
        submitting={noteUploads.posting}
        submitFailed={noteUploads.error || noteUploads.status === 'N'}
        submitSucceeded={noteUploads.status === 'Y'}
        invalid={invalidMessage.length > 0}
        reset={handleReset} />
    </form>
  </LgySubsection>

export default AddNoteSection
